var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.95,
    cy: 40.9632,
    r: 39.4807,
    fill: "white",
    stroke: "url(#paint0_linear_219_10266)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9494 63.9631C41.3198 63.9631 41.6751 63.816 41.937 63.5543C42.1989 63.2925 42.3461 62.9375 42.3461 62.5674H39.5526C39.5526 62.9375 39.6998 63.2925 39.9617 63.5543C40.2236 63.816 40.5789 63.9631 40.9494 63.9631Z",
    fill: "url(#paint1_linear_219_10266)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9891 28.1823C34.3655 25.8077 37.5886 24.4736 40.9493 24.4736C44.3099 24.4738 47.5328 25.808 49.909 28.1826C52.2852 30.5571 53.6202 33.7777 53.6202 37.1358C53.5906 39.0997 53.1625 41.0372 52.3619 42.8311C51.5612 44.6249 50.4046 46.2378 48.9621 47.5721C47.1976 49.2331 45.8548 51.2907 45.0453 53.574C45.0348 53.5732 45.0245 53.5718 45.0142 53.5704C44.9986 53.5683 44.983 53.5662 44.9667 53.5662H36.9323C36.919 53.5662 36.906 53.5681 36.893 53.5701C36.8801 53.5721 36.8671 53.574 36.8538 53.574C36.0441 51.2906 34.7012 49.2331 32.9365 47.5721C31.4939 46.2379 30.3372 44.625 29.5364 42.8312C28.7356 41.0373 28.3074 39.0998 28.2777 37.1358C28.2777 33.7775 29.6128 30.5569 31.9891 28.1823ZM49.787 37.0643V38.9172C49.7868 39.0539 49.7323 39.185 49.6354 39.2815C49.5386 39.3781 49.4073 39.4323 49.2705 39.4322H48.0226C47.8386 40.3371 47.4813 41.1979 46.9704 41.9673L47.8541 42.8504C47.9021 42.8982 47.9402 42.9551 47.9662 43.0177C47.9922 43.0803 48.0056 43.1474 48.0056 43.2152C48.0056 43.283 47.9922 43.3501 47.9662 43.4127C47.9402 43.4753 47.9021 43.5321 47.8541 43.58L46.543 44.8901C46.4951 44.9381 46.4381 44.9761 46.3754 45.0021C46.3128 45.028 46.2456 45.0414 46.1777 45.0414C46.1099 45.0414 46.0427 45.028 45.98 45.0021C45.9174 44.9761 45.8604 44.9381 45.8124 44.8901L44.9291 44.0074C44.1592 44.5176 43.2981 44.8745 42.3929 45.0585V46.3047C42.3929 46.3724 42.3796 46.4395 42.3537 46.5021C42.3278 46.5648 42.2898 46.6217 42.2418 46.6696C42.1939 46.7175 42.137 46.7556 42.0743 46.7815C42.0117 46.8074 41.9445 46.8208 41.8767 46.8208H40.022C39.9542 46.8208 39.8871 46.8074 39.8244 46.7815C39.7618 46.7556 39.7049 46.7175 39.6569 46.6696C39.609 46.6217 39.571 46.5648 39.5451 46.5021C39.5192 46.4395 39.5058 46.3724 39.5059 46.3047V45.0577C38.6007 44.8737 37.7395 44.5168 36.9697 44.0066L36.0863 44.8893C36.0383 44.9373 35.9814 44.9753 35.9187 45.0013C35.856 45.0272 35.7889 45.0406 35.721 45.0406C35.6532 45.0406 35.586 45.0272 35.5233 45.0013C35.4606 44.9753 35.4037 44.9373 35.3557 44.8893L34.0446 43.5792C33.9478 43.4824 33.8935 43.3512 33.8935 43.2144C33.8935 43.0776 33.9478 42.9464 34.0446 42.8496L34.9284 41.9665C34.4175 41.1973 34.0602 40.3368 33.8761 39.4322H32.6282C32.4914 39.4323 32.3602 39.3781 32.2633 39.2815C32.1665 39.185 32.1119 39.0539 32.1117 38.9172V37.0643C32.1119 36.9275 32.1664 36.7964 32.2633 36.6998C32.3601 36.6032 32.4914 36.5489 32.6282 36.5489H33.8761C34.0602 35.6443 34.4175 34.7838 34.9284 34.0146L34.0446 33.1319C33.9478 33.0351 33.8934 32.9038 33.8934 32.7669C33.8934 32.63 33.9478 32.4987 34.0446 32.4019L35.3557 31.0918C35.4527 30.995 35.584 30.9407 35.721 30.9407C35.858 30.9407 35.9894 30.995 36.0863 31.0918L36.9697 31.9749C37.7393 31.4641 38.6005 31.1068 39.5059 30.9226V29.6757C39.5058 29.6079 39.5192 29.5408 39.5451 29.4782C39.571 29.4156 39.609 29.3587 39.6569 29.3107C39.7049 29.2628 39.7618 29.2248 39.8244 29.1988C39.8871 29.1729 39.9542 29.1595 40.022 29.1595H41.8767C41.9445 29.1595 42.0117 29.1729 42.0743 29.1988C42.137 29.2248 42.1939 29.2628 42.2418 29.3107C42.2898 29.3587 42.3278 29.4156 42.3537 29.4782C42.3796 29.5408 42.3929 29.6079 42.3929 29.6757V30.9234C43.2982 31.1073 44.1593 31.4644 44.9291 31.9749L45.8124 31.0929C45.9094 30.9962 46.0407 30.9419 46.1777 30.9419C46.3147 30.9419 46.4461 30.9962 46.543 31.0929L47.8541 32.4031C47.9021 32.451 47.9402 32.5079 47.9661 32.5705C47.9921 32.6332 48.0055 32.7003 48.0055 32.7681C48.0055 32.8359 47.9921 32.903 47.9661 32.9656C47.9402 33.0283 47.9021 33.0852 47.8541 33.1331L46.9704 34.0158C47.481 34.7844 47.8383 35.6442 48.0226 36.5482H49.2705C49.4075 36.5482 49.5389 36.6025 49.6357 36.6993C49.7326 36.7961 49.787 36.9274 49.787 37.0643ZM38.602 41.501C39.2968 41.965 40.1137 42.2126 40.9494 42.2126C42.07 42.2126 43.1447 41.7677 43.937 40.976C44.7294 40.1842 45.1746 39.1103 45.1746 37.9906C45.1746 37.1555 44.9268 36.3392 44.4625 35.6449C43.9982 34.9506 43.3383 34.4095 42.5663 34.0899C41.7942 33.7704 40.9447 33.6868 40.1251 33.8497C39.3055 34.0126 38.5526 34.4147 37.9617 35.0051C37.3708 35.5956 36.9684 36.3479 36.8054 37.1669C36.6423 37.9859 36.726 38.8348 37.0458 39.6062C37.3656 40.3777 37.9072 41.0371 38.602 41.501Z",
    fill: "url(#paint2_linear_219_10266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2831 60.1001V60.6064C37.2831 61.1269 37.49 61.626 37.8583 61.9941C38.2266 62.3621 38.7261 62.5689 39.247 62.5689H42.6517C43.1725 62.5689 43.6721 62.3621 44.0404 61.9941C44.4087 61.626 44.6156 61.1269 44.6156 60.6064V60.1001H37.2831Z",
    fill: "url(#paint3_linear_219_10266)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9664 53.5674H36.932C36.3302 53.5674 35.8424 54.0548 35.8424 54.6562C35.8424 55.2575 36.3302 55.7449 36.932 55.7449H44.9664C45.5682 55.7449 46.056 55.2575 46.056 54.6562C46.056 54.0548 45.5682 53.5674 44.9664 53.5674Z",
    fill: "url(#paint4_linear_219_10266)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9664 55.7446H36.932C36.3302 55.7446 35.8424 56.2321 35.8424 56.8334C35.8424 57.4347 36.3302 57.9222 36.932 57.9222H44.9664C45.5682 57.9222 46.056 57.4347 46.056 56.8334C46.056 56.2321 45.5682 55.7446 44.9664 55.7446Z",
    fill: "url(#paint5_linear_219_10266)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9664 57.9219H36.932C36.3302 57.9219 35.8424 58.4093 35.8424 59.0106C35.8424 59.612 36.3302 60.0994 36.932 60.0994H44.9664C45.5682 60.0994 46.056 59.612 46.056 59.0106C46.056 58.4093 45.5682 57.9219 44.9664 57.9219Z",
    fill: "url(#paint6_linear_219_10266)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5557 37.5537H56.9358C56.8316 37.5537 56.7317 37.5951 56.658 37.6687C56.5844 37.7423 56.543 37.8421 56.543 37.9462C56.543 38.0503 56.5844 38.1501 56.658 38.2237C56.7317 38.2973 56.8316 38.3387 56.9358 38.3387H60.5572C60.6614 38.3387 60.7613 38.2973 60.835 38.2237C60.9086 38.1501 60.95 38.0503 60.95 37.9462C60.95 37.8421 60.9086 37.7423 60.835 37.6687C60.7613 37.5951 60.6614 37.5537 60.5572 37.5537H60.5557Z",
    fill: "url(#paint7_linear_219_10266)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.963 37.5537H21.3427C21.2386 37.5537 21.1387 37.5951 21.065 37.6687C20.9913 37.7423 20.95 37.8421 20.95 37.9462C20.95 38.0503 20.9913 38.1501 21.065 38.2237C21.1387 38.2973 21.2386 38.3387 21.3427 38.3387H24.963C25.0672 38.3387 25.1671 38.2973 25.2408 38.2237C25.3144 38.1501 25.3558 38.0503 25.3558 37.9462C25.3558 37.8421 25.3144 37.7423 25.2408 37.6687C25.1671 37.5951 25.0672 37.5537 24.963 37.5537Z",
    fill: "url(#paint8_linear_219_10266)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5355 23.8153L51.9749 26.3743C51.9374 26.4105 51.9075 26.4538 51.8869 26.5017C51.8663 26.5496 51.8554 26.6011 51.855 26.6532C51.8545 26.7053 51.8645 26.757 51.8842 26.8052C51.904 26.8535 51.9331 26.8973 51.97 26.9341C52.0069 26.971 52.0508 27.0001 52.099 27.0199C52.1473 27.0396 52.199 27.0495 52.2512 27.0491C52.3033 27.0486 52.3549 27.0378 52.4028 27.0172C52.4507 26.9967 52.4941 26.9668 52.5303 26.9293L55.0897 24.3702C55.1612 24.2962 55.2008 24.1971 55.1999 24.0942C55.199 23.9912 55.1577 23.8928 55.0849 23.82C55.0121 23.7473 54.9135 23.706 54.8106 23.7051C54.7076 23.7042 54.6084 23.7438 54.5343 23.8153H54.5355Z",
    fill: "url(#paint9_linear_219_10266)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3685 48.963L26.8091 51.5209C26.7716 51.5571 26.7417 51.6004 26.7211 51.6483C26.7005 51.6961 26.6897 51.7476 26.6892 51.7998C26.6888 51.8519 26.6987 51.9036 26.7185 51.9518C26.7382 52 26.7674 52.0439 26.8043 52.0807C26.8411 52.1176 26.885 52.1467 26.9333 52.1664C26.9815 52.1862 27.0333 52.1961 27.0854 52.1956C27.1376 52.1952 27.1891 52.1844 27.237 52.1638C27.2849 52.1432 27.3283 52.1133 27.3645 52.0758L29.9239 49.5192C29.9955 49.4451 30.035 49.346 30.0341 49.2431C30.0333 49.1402 29.9919 49.0417 29.9191 48.969C29.8463 48.8962 29.7478 48.8549 29.6448 48.854C29.5418 48.8531 29.4426 48.8927 29.3685 48.9642V48.963Z",
    fill: "url(#paint10_linear_219_10266)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9494 22.3655C41.0536 22.3655 41.1535 22.3241 41.2272 22.2505C41.3008 22.1769 41.3422 22.0771 41.3422 21.973V18.3554C41.3422 18.2513 41.3008 18.1515 41.2272 18.0778C41.1535 18.0042 41.0536 17.9629 40.9494 17.9629C40.8453 17.9629 40.7453 18.0042 40.6717 18.0778C40.598 18.1515 40.5566 18.2513 40.5566 18.3554V21.9745C40.5571 22.0784 40.5986 22.1778 40.6722 22.251C40.7459 22.3243 40.8455 22.3655 40.9494 22.3655Z",
    fill: "url(#paint11_linear_219_10266)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5302 48.9634C52.4564 48.8898 52.3564 48.8485 52.2521 48.8486C52.1478 48.8487 52.0479 48.8902 51.9742 48.964C51.9006 49.0377 51.8593 49.1377 51.8594 49.2419C51.8595 49.3461 51.901 49.446 51.9748 49.5196L54.5354 52.0782C54.6093 52.1516 54.7094 52.1927 54.8136 52.1924C54.9178 52.1921 55.0177 52.1505 55.0912 52.0766C55.1647 52.0028 55.2058 51.9028 55.2055 51.7986C55.2052 51.6945 55.1635 51.5947 55.0896 51.5213L52.5302 48.9634Z",
    fill: "url(#paint12_linear_219_10266)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3685 26.9292C29.4426 27.0007 29.5418 27.0403 29.6448 27.0394C29.7478 27.0385 29.8463 26.9972 29.9191 26.9245C29.992 26.8517 30.0333 26.7532 30.0342 26.6503C30.0351 26.5474 29.9955 26.4483 29.9239 26.3743L27.3634 23.8152C27.2886 23.7477 27.1906 23.7114 27.0899 23.714C26.9891 23.7166 26.8931 23.7578 26.8219 23.8291C26.7507 23.9004 26.7096 23.9964 26.7073 24.0971C26.7049 24.1978 26.7414 24.2956 26.8091 24.3702L29.3685 26.9292Z",
    fill: "url(#paint13_linear_219_10266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_10266",
    x1: 40.95,
    y1: 0.982422,
    x2: 40.95,
    y2: 80.9439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_10266",
    x1: 40.9494,
    y1: 62.5674,
    x2: 40.9494,
    y2: 63.9631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_219_10266",
    x1: 40.9489,
    y1: 24.4736,
    x2: 40.9489,
    y2: 53.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_219_10266",
    x1: 40.9493,
    y1: 60.1001,
    x2: 40.9493,
    y2: 62.5689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_219_10266",
    x1: 40.9492,
    y1: 53.5674,
    x2: 40.9492,
    y2: 55.7449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_219_10266",
    x1: 40.9492,
    y1: 55.7446,
    x2: 40.9492,
    y2: 57.9222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_219_10266",
    x1: 40.9492,
    y1: 57.9219,
    x2: 40.9492,
    y2: 60.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_219_10266",
    x1: 58.7465,
    y1: 37.5537,
    x2: 58.7465,
    y2: 38.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_219_10266",
    x1: 23.1529,
    y1: 37.5537,
    x2: 23.1529,
    y2: 38.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_219_10266",
    x1: 53.5275,
    y1: 23.7051,
    x2: 53.5275,
    y2: 27.0491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_219_10266",
    x1: 28.3617,
    y1: 48.854,
    x2: 28.3617,
    y2: 52.1957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_219_10266",
    x1: 40.9494,
    y1: 17.9629,
    x2: 40.9494,
    y2: 22.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_219_10266",
    x1: 53.5324,
    y1: 48.8486,
    x2: 53.5324,
    y2: 52.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_219_10266",
    x1: 28.3707,
    y1: 23.7139,
    x2: 28.3707,
    y2: 27.0394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.348fd9195f75bebb2d128a8a3240d84a.svg";
export { ForwardRef as ReactComponent };